import React from "react";
import Login from "../pages/auth/login";
import Signup from "../pages/auth/signup";
import ForgotPassword from "../pages/auth/forgot-password";
import ResetPassword from "../pages/auth/reset-password";
import Page from "@jumbo/shared/Page";
import LAYOUT_NAMES from "app/layouts/layouts";

const authRoutes = [
    {
        path: "/auth/login",
        element: <Page component={Login} layout="solo-page" />,
    },
    // {
    //     path: "/auth/signup",
    //     element: <Page component={Signup} layout="solo-page" />
    // },
    {
        path: "/auth/forgot-password",
        element: <Page component={ForgotPassword} layout="solo-page" />
    },
    {
        path: "/auth/reset-password",
        element: <Page component={ResetPassword} layout="solo-page" />
    }
];

export default authRoutes;
